var map = {
	"./Frame 3481.png": 396,
	"./LOGO@2x.png": 397,
	"./arrow-down-blue.svg": 398,
	"./arrow-down-grey.svg": 399,
	"./arrow-right-white.png": 400,
	"./arrow-right.svg": 401,
	"./bg.png": 402,
	"./binance-logo.png": 175,
	"./binance.svg": 403,
	"./blue-loader.svg": 176,
	"./circle-grey.svg": 404,
	"./circle.svg": 405,
	"./coinbaseWalletIcon.svg": 129,
	"./dropdown-blue.svg": 406,
	"./dropdown.svg": 407,
	"./dropup-blue.svg": 408,
	"./ethereum-logo.png": 409,
	"./fortmaticIcon.png": 130,
	"./image_flip.png": 410,
	"./link.svg": 411,
	"./logob.png": 412,
	"./logoh.png": 413,
	"./logow.png": 414,
	"./magnifying-glass.svg": 415,
	"./menu.svg": 416,
	"./metamask.png": 177,
	"./plus-blue.svg": 417,
	"./plus-grey.svg": 418,
	"./portisIcon.png": 131,
	"./question-mark.svg": 419,
	"./question.svg": 420,
	"./spinner.svg": 421,
	"./stax_b.png": 171,
	"./stax_w.png": 170,
	"./trustWallet.png": 422,
	"./walletConnectIcon.svg": 132,
	"./wbnb.png": 423,
	"./x.svg": 424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;